import store from '@store'
import { MessageBox } from 'element-ui'
import axios from 'axios'

let isRefreshToken = false

/**
 * 刷新token
 */
function refreshToken () {
  isRefreshToken = true
  store.dispatch('refreshToken').then(({data}) => {
    store.commit('LOGIN', data.jwt)
    isRefreshToken = false
  })
}

function showAlert (promise) {
  return promise.catch((thrown) => {
    if (!axios.isCancel(thrown)) {
      if (thrown.response) {
        if (thrown.response.data.hasOwnProperty('ret') && thrown.response.data.hasOwnProperty('msg')) {
          MessageBox.alert(thrown.response.data.msg, '错误提示', {type: 'thrown'})
        } else {
          MessageBox.alert(thrown.response.data.toString(), '响应错误', {type: 'thrown'})
        }
      } else {
        MessageBox.alert(thrown.toString(), '错误提示', {type: 'thrown'})
      }
    }
    // 返回响应错误
    return Promise.reject(thrown)
  })
}

function handleData (promise) {
  return promise.then((response) => {
    // 刷新token
    if (response.headers['sj-auth-require-refresh'] && !isRefreshToken) {
      refreshToken()
    }
    // 响应数据处理
    let data = response.data
    let error = null
    if (data.hasOwnProperty('ret')) {
      // 服务报错
      if (data.ret) {
        if (data.ret === 855) {
          Router.push('/settings/change-password?showDefaultPasswordHint=1')
        }
        // 含响应消息
        if (data.msg) {
          error = new Error(data.msg.toString())
        } else {
          error = new Error(data.toString())
        }
      } else {
        // 正确响应
        if (data.hasOwnProperty('detail')) {
          response.data = data.detail
        }
        return response
      }
    } else {
      error = new Error(data.toString())
    }
    error.response = response
    // 抛出异常
    return Promise.reject(error)
  })
}

function showLoading (promise) {
  store.commit('OPEN_LOADING')
  return promise.finally(() => {
    store.commit('CLOSE_LOADING', 1)
  })
}

function request (name, params, config) {
  return handleData(request.dispatch(name, params, config))
}

function getRequestItems () {
  let items = {}
  let models = require('@utils/requires').requires(require.context('@views', true, /\.api\.js$/), false)
  // 模块列表
  for (let path in models) {
    if (models.hasOwnProperty(path)) {
      // 请求列表
      for (let name in models[path]) {
        if (models[path].hasOwnProperty(name)) {
          // api 是否已存在
          if (items.hasOwnProperty(name)) {
            console.error(`${items[name].path} 和 ${path} 中的 ${name} 方法冲突。`)
          } else {
            items[name] = models[path][name]
            items[name].path = path
          }
        }
      }
    }
  }
  return items
}

/**
 * 异常响应
 * @param thrown
 */
function exceptionResponse (thrown) {
  if (axios.isCancel(thrown)) {
    console.warn('Request canceled', thrown.message)
  } else {
    // 存在响应
    if (thrown.response) {
      // 请求失败
      if (thrown.response.status > 200) {
        Router.push('/exception/404')
      } else {
        // 响应无权限
        if (thrown.response.data) {
          if (thrown.response.data.ret === 403) {
            Router.push('/exception/403')
            return
          }
          if (thrown.response.data.ret === 855) {
            Router.push('/settings/change-password?showDefaultPasswordHint=1')
            return
          }
        }
        // 响应的内容无法解析
        Router.push('/exception/424')
      }
    }
  }
}

request.items = getRequestItems()

request.dispatch = (name, params, config) => {
  return request.items[name](params, config)
}

request.alert = (name, params, config) => {
  return showAlert(request(name, params, config))
}

request.loading = (name, params, config) => {
  return showLoading(request(name, params, config))
}

request.common = (name, params, config) => {
  return showLoading(showAlert(request(name, params, config)))
}

request.all = (items) => {
  return Promise.all(items)
}

request.all.common = (items) => {
  store.commit('OPEN_LOADING')
  return showAlert(Promise.all(items)).finally(() => {
    store.commit('CLOSE_LOADING', 1)
  })
}

request.all.loading = (items) => {
  store.commit('OPEN_LOADING')
  return Promise.all(items).finally(() => {
    store.commit('CLOSE_LOADING', 1)
  })
}

request.all.alert = (items) => {
  return showAlert(Promise.all(items))
}

request.page = (name, params, config) => {
  store.commit('OPEN_LOADING')
  return request(name, params, config).catch((error) => {
    // 异常响应
    exceptionResponse(error)
    // 抛出异常
    return Promise.reject(error)
  }).finally(() => {
    store.commit('CLOSE_LOADING', 1)
  })
}

request.all.page = (items) => {
  store.commit('OPEN_LOADING')
  return Promise.all(items).catch((error) => {
    // 异常响应
    exceptionResponse(error)
    // 抛出异常
    return Promise.reject(error)
  }).finally(() => {
    store.commit('CLOSE_LOADING', 1)
  })
}

request.map = (items) => {
  let requests = {}
  items.forEach((name) => {
    requests[name] = function (params, config) {
      return request(name, params, config)
    }
  })
  return requests
}

// 取消请求操作
request.cancelAll = () => {}
request.cancelToken = null
request.createCancelToken = () => {
  let source = axios.CancelToken.source()
  request.cancelAll = source.cancel
  request.cancelToken = source.token
}


export default request



// WEBPACK FOOTER //
// ./core/api/request.js